import { Component, OnDestroy, AfterViewInit, Output, EventEmitter, ElementRef, Input } from '@angular/core';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'ngx-tiny-mce',
  template: '',
})
export class TinyMCEComponent implements OnDestroy, AfterViewInit {

  @Input() initialContent: string;
  @Output() editorChange = new EventEmitter<any>();

  editor: any;

  constructor(
    private host: ElementRef,
    private locationStrategy: LocationStrategy,
  ) { }

  ngAfterViewInit() {
    tinymce.init({
      target: this.host.nativeElement,
      plugins: ['link', 'paste', 'table'],
      skin_url: `${this.locationStrategy.getBaseHref()}assets/skins/lightgray`,
      setup: editor => {
        this.editor = editor;
        editor.on('change', () => {
          this.editorChange.emit(editor.getContent());
        });
      },
      height: '320',
      init_instance_callback: (inst) => { inst.setContent(this.initialContent) },
      language: 'pt_BR',
      language_url : '/assets/tinymce_pt_BR.js'
    });
  }

  ngOnDestroy() {
    tinymce.remove(this.editor);
  }
}
